export const calcRefundAmountByPercentage = (amount: number, percentage: number) => {
  const refund = (amount * percentage) / 100;
  return parseFloat(refund.toFixed(2));
};
